module.exports = __webpack_public_path__ + "img/审计.eab1563f.jpg";